export default (
    component_name,
    weekDays,
    options = {
        multiple: false,
        required: false,
        initialValues: undefined,
    }
) => ({
    weekDays: weekDays,
    selectedDays: null,

    toggleSelectAll: false,
    isSubmitted    : false,
    isDisabled: false,

    init(){
        this.$watch('selectedDays', (value, old) => {
            if(options.multiple){
                const sortedDays = [...this.selectedDays].sort((a, b) => a - b);
                this.$dispatch(`${component_name}-change`, [sortedDays, this.isValid]);
                return;
            }
            this.$dispatch(`${component_name}-change`, [value, this.isValid]);
        });

        this.$watch('toggleSelectAll', value => {
            if(value){
                this.selectedDays = Array.from({ length: 7 }, (v, i) => i + 1); //? Seleccionar todos los dias
            }else{
                this.selectedDays = [];
            }
        });

        if (options.initialValues !== undefined && options.initialValues !== null) {
            this.selectedDays = options.multiple && options.multiple === true ? [...options.initialValues] : options.initialValues;
        }else{
            this.selectedDays = options.multiple && options.multiple === true ? [] : undefined;
        }
    },

    get isValid(){
        if(options.required === true){
            return options.multiple
                ? this.selectedDays.length > 0
                : this.selectedDays !== undefined;
        }
        return true;
    }
});
